module.exports = __webpack_public_path__ + "static/media/6.eaa1804a.jpg";